const PENDING_BEAMER_POSTS = 'PENDING_BEAMER_POSTS';
const OPENED_WHATS_NEW = 'OPENED_WHATS_NEW';

export { PENDING_BEAMER_POSTS, OPENED_WHATS_NEW };
